import { monsterStats } from '../../content/balance';
import { HOLLOW_KNIGHT } from '../../content/monsters/keep';
import type { MonsterDef } from '../../sim/registry';
import { registry } from '../../sim/registry';
import { RIFT } from './rules';

/**
 * Instance-only actors: Rift Delve pickup orbs (neutral helpers the host
 * spawns and consumes) and the Crucible's sparring knights (bots that fill an
 * empty team so a solo or one-sided match can still be played). Every peer
 * must register them, since replicated monsters are rebuilt from their def.
 */

export type OrbKind = 'wind' | 'health' | 'power';

export const ORB_DEF: Record<OrbKind, string> = {
  wind: 'rift_orb_wind',
  health: 'rift_orb_health',
  power: 'rift_orb_power',
};

const orb = (id: string, name: string, tint: number): MonsterDef => ({
  id,
  name,
  grade: 'minion',
  model: 'fx_orb',
  scale: 1.3,
  radius: 0.1,
  tint,
  stats: (l) => monsterStats(l, 'minion'),
  skills: [],
  brain: 'none',
  aggroRange: 0,
  leash: 99,
  xp: 0,
  loot: null,
  params: { helper: true, pickupRadius: RIFT.pickupRadius, immovable: true },
});

export const SPARRER_ID = 'crucible_sparrer';

export const INSTANCE_MONSTERS: MonsterDef[] = [
  orb(ORB_DEF.wind, 'Tailwind Mote', 0x7ad8ff),
  orb(ORB_DEF.health, 'Mending Mote', 0x7bd66b),
  orb(ORB_DEF.power, 'Fury Mote', 0xff7a3a),
  {
    ...HOLLOW_KNIGHT,
    id: SPARRER_ID,
    name: 'Sparring Knight',
    title: 'Crucible Champion',
    stats: (l) => monsterStats(l, 'elite', { hp: 0.9, atk: 0.7, speed: 1.05 }),
    aggroRange: 60,
    leash: 99,
    xp: 0,
    loot: null,
  },
];

/** Registers the instance actors (safe to call more than once). */
export function registerInstanceContent(): void {
  for (const m of INSTANCE_MONSTERS) if (!registry.monsters.has(m.id)) registry.registerMonster(m);
}
